
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
::slotted([slot='title']) {

    font-family: var(--bh-ff-body);

    font-size: var(--bh-fs-heading-03);

    line-height: var(--bh-lh-heading-03);

    letter-spacing: var(--bh-ls-heading-03);

    font-weight: var(--fw-bold)
}

::slotted([slot='price']) {

    font-size: var(--bh-fs-body-02);

    line-height: var(--bh-lh-body-02);

    letter-spacing: var(--bh-ls-body-02);

    font-weight: var(--fw-bold);

    color: var(--bh-brand-primary-default)
}

.event-detail-item {

    padding-left: 2rem;

    padding-right: 2rem
}

.event-detail-item, .event-detail-content {

    display: flex;

    flex-direction: column;

    gap: 1rem
}
`;